// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

var emailValidationRegex = /^[a-zA-Z0-9._%+-]*[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]*$/;

function decodeAmount(dict, defaultAmount) {
  var amount = dict["amount"];
  if (amount !== undefined) {
    return Core__Option.getOr(Core__JSON.Decode.string(amount), defaultAmount);
  } else {
    return defaultAmount;
  }
}

function decodeFlow(dict, defaultPaymentMethodCollectFlow) {
  var flow = dict["flow"];
  if (flow === undefined) {
    return defaultPaymentMethodCollectFlow;
  }
  var match = Core__JSON.Decode.string(flow);
  if (match === undefined) {
    return defaultPaymentMethodCollectFlow;
  }
  switch (match) {
    case "PayoutLinkInitiate" :
        return "PayoutLinkInitiate";
    case "PayoutMethodCollect" :
        return "PayoutMethodCollect";
    default:
      return defaultPaymentMethodCollectFlow;
  }
}

function decodeFormLayout(dict, defaultFormLayout) {
  var formLayout = dict["formLayout"];
  if (formLayout === undefined) {
    return defaultFormLayout;
  }
  var match = Core__JSON.Decode.string(formLayout);
  if (match === undefined) {
    return defaultFormLayout;
  }
  switch (match) {
    case "journey" :
        return "Journey";
    case "tabs" :
        return "Tabs";
    default:
      return defaultFormLayout;
  }
}

function decodeCard(cardType) {
  switch (cardType) {
    case "credit" :
        return "Credit";
    case "debit" :
        return "Debit";
    default:
      return ;
  }
}

function decodeTransfer(value) {
  switch (value) {
    case "ach" :
        return "ACH";
    case "bacs" :
        return "Bacs";
    case "pix" :
        return "Pix";
    case "sepa_bank_transfer" :
        return "Sepa";
    default:
      return ;
  }
}

function decodeWallet(methodType) {
  switch (methodType) {
    case "paypal" :
        return "Paypal";
    case "venmo" :
        return "Venmo";
    default:
      return ;
  }
}

function decodeBankRedirect(methodType) {
  if (methodType === "interac") {
    return "Interac";
  }
  
}

function getFieldOptions(dict) {
  var dict$1 = Core__JSON.Classify.classify(Core__Option.getOr(dict["field_type"], {}));
  if (typeof dict$1 !== "object" || dict$1.TAG !== "Object") {
    return ;
  } else {
    return Core__Option.flatMap(Core__Option.flatMap(dict$1._0["user_address_country"], Core__JSON.Decode.object), (function (obj) {
                  return Core__Option.map(Core__Option.flatMap(obj["options"], Core__JSON.Decode.array), (function (options) {
                                var countries = Core__Array.filterMap(options, (function (option) {
                                        return Core__JSON.Decode.string(option);
                                      }));
                                countries.sort(function (c1, c2) {
                                      return (c1.charCodeAt(0) | 0) - (c2.charCodeAt(0) | 0) | 0;
                                    });
                                return {
                                        TAG: "BillingAddress",
                                        _0: {
                                          TAG: "AddressCountry",
                                          _0: countries
                                        }
                                      };
                              }));
                }));
  }
}

function decodeFieldType(key, fieldType) {
  switch (key) {
    case "billing.address.city" :
        return {
                TAG: "BillingAddress",
                _0: "AddressCity"
              };
    case "billing.address.country" :
        if (fieldType === undefined) {
          return fieldType;
        }
        if (fieldType.TAG !== "BillingAddress") {
          return fieldType;
        }
        var countries = fieldType._0;
        if (typeof countries !== "object" || countries.TAG !== "AddressCountry") {
          return fieldType;
        } else {
          return {
                  TAG: "BillingAddress",
                  _0: {
                    TAG: "AddressCountry",
                    _0: countries._0
                  }
                };
        }
    case "billing.address.first_name" :
        return {
                TAG: "BillingAddress",
                _0: {
                  TAG: "FullName",
                  _0: "FirstName"
                }
              };
    case "billing.address.last_name" :
        return {
                TAG: "BillingAddress",
                _0: {
                  TAG: "FullName",
                  _0: "LastName"
                }
              };
    case "billing.address.line1" :
        return {
                TAG: "BillingAddress",
                _0: "AddressLine1"
              };
    case "billing.address.line2" :
        return {
                TAG: "BillingAddress",
                _0: "AddressLine2"
              };
    case "billing.address.state" :
        return {
                TAG: "BillingAddress",
                _0: "AddressState"
              };
    case "billing.address.zip" :
        return {
                TAG: "BillingAddress",
                _0: "AddressPincode"
              };
    case "billing.phone.country_code" :
        return {
                TAG: "BillingAddress",
                _0: "PhoneCountryCode"
              };
    case "billing.phone.number" :
        return {
                TAG: "BillingAddress",
                _0: "PhoneNumber"
              };
    case "payout_method_data.bank.bic" :
        return {
                TAG: "PayoutMethodData",
                _0: "SepaBic"
              };
    case "payout_method_data.bank.iban" :
        return {
                TAG: "PayoutMethodData",
                _0: "SepaIban"
              };
    case "payout_method_data.card.card_holder_name" :
        return {
                TAG: "PayoutMethodData",
                _0: "CardHolderName"
              };
    case "payout_method_data.card.card_number" :
        return {
                TAG: "PayoutMethodData",
                _0: "CardNumber"
              };
    case "payout_method_data.card.expiry_month" :
        return {
                TAG: "PayoutMethodData",
                _0: {
                  TAG: "CardExpDate",
                  _0: "CardExpMonth"
                }
              };
    case "payout_method_data.card.expiry_year" :
        return {
                TAG: "PayoutMethodData",
                _0: {
                  TAG: "CardExpDate",
                  _0: "CardExpYear"
                }
              };
    default:
      return fieldType;
  }
}

var customAddressOrder = [
  "billing.address.first_name",
  "billing.address.last_name",
  "billing.address.line1",
  "billing.address.line2",
  "billing.address.city",
  "billing.address.zip",
  "billing.address.state",
  "billing.address.country",
  "billing.phone.country_code",
  "billing.phone.number"
];

var customPmdOrder = [
  "payout_method_data.card.card_number",
  "payout_method_data.card.expiry_month",
  "payout_method_data.card.expiry_year",
  "payout_method_data.card.card_holder_name",
  "payout_method_data.bank.iban",
  "payout_method_data.bank.bic"
];

function createCustomOrderMap(customOrder) {
  return Core__Array.reduceWithIndex(customOrder, new Map(), (function (map, item, index) {
                map.set(item, index);
                return map;
              }));
}

function getCustomIndex(key, customOrderMap, defaultIndex) {
  var index = customOrderMap.get(key);
  if (index !== undefined) {
    return Caml_option.valFromOption(index);
  } else {
    return defaultIndex;
  }
}

function sortByCustomOrder(arr, getKey, customOrder) {
  var customOrderMap = createCustomOrderMap(customOrder);
  var defaultIndex = customOrder.length;
  return arr.sort(function (a, b) {
              var indexA = getCustomIndex(getKey(a), customOrderMap, defaultIndex);
              var indexB = getCustomIndex(getKey(b), customOrderMap, defaultIndex);
              return indexA - indexB | 0;
            });
}

function decodePayoutDynamicFields(json, defaultDynamicPmdFields) {
  return Core__Option.mapOr(Core__JSON.Decode.object(json), {
              address: undefined,
              payoutMethodData: defaultDynamicPmdFields
            }, (function (obj) {
                var match = Core__Array.reduce(Js_dict.entries(obj), [
                      [],
                      []
                    ], (function (param, param$1) {
                        var payoutMethodDataFields = param[1];
                        var addressFields = param[0];
                        var fieldObj = Core__JSON.Decode.object(param$1[1]);
                        if (fieldObj === undefined) {
                          return [
                                  addressFields,
                                  payoutMethodDataFields
                                ];
                        }
                        var getString = function (key) {
                          return Core__Option.flatMap(fieldObj[key], Core__JSON.Decode.string);
                        };
                        var fieldType = getFieldOptions(fieldObj);
                        var match = getString("required_field");
                        var match$1 = getString("display_name");
                        var match$2 = getString("value");
                        if (match === undefined) {
                          return [
                                  addressFields,
                                  payoutMethodDataFields
                                ];
                        }
                        if (match$1 === undefined) {
                          return [
                                  addressFields,
                                  payoutMethodDataFields
                                ];
                        }
                        var match$3 = decodeFieldType(param$1[0], fieldType);
                        if (match$3 === undefined) {
                          return [
                                  addressFields,
                                  payoutMethodDataFields
                                ];
                        }
                        if (match$3.TAG === "BillingAddress") {
                          var addressField_fieldType = match$3._0;
                          var addressField = {
                            pmdMap: match,
                            displayName: match$1,
                            fieldType: addressField_fieldType,
                            value: match$2
                          };
                          return [
                                  Belt_Array.concatMany([
                                        [addressField],
                                        addressFields
                                      ]),
                                  payoutMethodDataFields
                                ];
                        }
                        var payoutMethodDataField_fieldType = match$3._0;
                        var payoutMethodDataField = {
                          pmdMap: match,
                          displayName: match$1,
                          fieldType: payoutMethodDataField_fieldType,
                          value: match$2
                        };
                        return [
                                addressFields,
                                Belt_Array.concatMany([
                                      [payoutMethodDataField],
                                      payoutMethodDataFields
                                    ])
                              ];
                      }));
                var pmd = match[1];
                var address = match[0];
                return {
                        address: address.length > 0 ? sortByCustomOrder(address, (function (item) {
                                  return item.pmdMap;
                                }), customAddressOrder) : undefined,
                        payoutMethodData: pmd.length > 0 ? sortByCustomOrder(pmd, (function (item) {
                                  return item.pmdMap;
                                }), customPmdOrder) : defaultDynamicPmdFields
                      };
              }));
}

function decodePaymentMethodTypeWithRequiredFields(json, defaultDynamicPmdFields) {
  return Core__Option.flatMap(Core__JSON.Decode.object(json), (function (obj) {
                var paymentMethod = Core__Option.flatMap(obj["payment_method"], Core__JSON.Decode.string);
                return Core__Option.map(Core__Option.flatMap(obj["payment_method_types_info"], Core__JSON.Decode.array), (function (pmtInfoArr) {
                              return Core__Array.reduce(Belt_Array.keepMap(pmtInfoArr, (function (pmtInfo) {
                                                return Core__Option.flatMap(Core__JSON.Decode.object(pmtInfo), (function (obj) {
                                                              var paymentMethodType = Core__Option.flatMap(obj["payment_method_type"], Core__JSON.Decode.string);
                                                              var tmp;
                                                              if (paymentMethod !== undefined) {
                                                                switch (paymentMethod) {
                                                                  case "bank_redirect" :
                                                                      tmp = paymentMethodType !== undefined ? Core__Option.map(decodeBankRedirect(paymentMethodType), (function (bankRedirect) {
                                                                                return {
                                                                                        TAG: "BankRedirect",
                                                                                        _0: bankRedirect
                                                                                      };
                                                                              })) : undefined;
                                                                      break;
                                                                  case "bank_transfer" :
                                                                      tmp = paymentMethodType !== undefined ? Core__Option.map(decodeTransfer(paymentMethodType), (function (transfer) {
                                                                                return {
                                                                                        TAG: "BankTransfer",
                                                                                        _0: transfer
                                                                                      };
                                                                              })) : undefined;
                                                                      break;
                                                                  case "card" :
                                                                      tmp = paymentMethodType !== undefined ? Core__Option.map(decodeCard(paymentMethodType), (function (card) {
                                                                                return {
                                                                                        TAG: "Card",
                                                                                        _0: card
                                                                                      };
                                                                              })) : undefined;
                                                                      break;
                                                                  case "wallet" :
                                                                      tmp = paymentMethodType !== undefined ? Core__Option.map(decodeWallet(paymentMethodType), (function (wallet) {
                                                                                return {
                                                                                        TAG: "Wallet",
                                                                                        _0: wallet
                                                                                      };
                                                                              })) : undefined;
                                                                      break;
                                                                  default:
                                                                    tmp = undefined;
                                                                }
                                                              } else {
                                                                tmp = undefined;
                                                              }
                                                              return Core__Option.map(tmp, (function (pmt) {
                                                                            var payoutDynamicFields = Core__Option.getOr(Core__Option.map(obj["required_fields"], (function (json) {
                                                                                        return decodePayoutDynamicFields(json, defaultDynamicPmdFields(pmt));
                                                                                      })), {
                                                                                  address: undefined,
                                                                                  payoutMethodData: defaultDynamicPmdFields(pmt)
                                                                                });
                                                                            return [
                                                                                    pmt,
                                                                                    payoutDynamicFields
                                                                                  ];
                                                                          }));
                                                            }));
                                              })), [
                                          [],
                                          []
                                        ], (function (param, param$1) {
                                            var payoutDynamicFields = param$1[1];
                                            var pmt = param$1[0];
                                            var pmtr = param[1];
                                            var pmta = param[0];
                                            switch (pmt.TAG) {
                                              case "Card" :
                                                  var card = pmt._0;
                                                  pmta.push({
                                                        TAG: "Card",
                                                        _0: card
                                                      });
                                                  var pmtwr = {
                                                    TAG: "Card",
                                                    _0: [
                                                      card,
                                                      payoutDynamicFields
                                                    ]
                                                  };
                                                  pmtr.push(pmtwr);
                                                  return [
                                                          pmta,
                                                          pmtr
                                                        ];
                                              case "BankRedirect" :
                                                  var bankRedirect = pmt._0;
                                                  pmta.push({
                                                        TAG: "BankRedirect",
                                                        _0: bankRedirect
                                                      });
                                                  pmtr.push({
                                                        TAG: "BankRedirect",
                                                        _0: [
                                                          bankRedirect,
                                                          payoutDynamicFields
                                                        ]
                                                      });
                                                  return [
                                                          pmta,
                                                          pmtr
                                                        ];
                                              case "BankTransfer" :
                                                  var transfer = pmt._0;
                                                  pmta.push({
                                                        TAG: "BankTransfer",
                                                        _0: transfer
                                                      });
                                                  pmtr.push({
                                                        TAG: "BankTransfer",
                                                        _0: [
                                                          transfer,
                                                          payoutDynamicFields
                                                        ]
                                                      });
                                                  return [
                                                          pmta,
                                                          pmtr
                                                        ];
                                              case "Wallet" :
                                                  var wallet = pmt._0;
                                                  var pmt$1 = {
                                                    TAG: "Wallet",
                                                    _0: wallet
                                                  };
                                                  pmta.push(pmt$1);
                                                  pmtr.push({
                                                        TAG: "Wallet",
                                                        _0: [
                                                          wallet,
                                                          payoutDynamicFields
                                                        ]
                                                      });
                                                  return [
                                                          pmta,
                                                          pmtr
                                                        ];
                                              
                                            }
                                          }));
                            }));
              }));
}

function decodePayoutConfirmResponse(json) {
  var obj = Core__JSON.Decode.object(json);
  if (obj === undefined) {
    return ;
  }
  var match = Core__Option.flatMap(obj["status"], Core__JSON.Decode.string);
  var status;
  if (match !== undefined) {
    switch (match) {
      case "cancelled" :
          status = "Cancelled";
          break;
      case "expired" :
          status = "Expired";
          break;
      case "failed" :
          status = "Failed";
          break;
      case "ineligible" :
          status = "Ineligible";
          break;
      case "initiated" :
          status = "Initiated";
          break;
      case "pending" :
          status = "Pending";
          break;
      case "requires_confirmation" :
          status = "RequiresConfirmation";
          break;
      case "requires_creation" :
          status = "RequiresCreation";
          break;
      case "requires_fulfillment" :
          status = "RequiresFulfillment";
          break;
      case "requires_payout_method_data" :
          status = "RequiresPayoutMethodData";
          break;
      case "requires_vendor_account_creation" :
          status = "RequiresVendorAccountCreation";
          break;
      case "reversed" :
          status = "Reversed";
          break;
      case "success" :
          status = "Success";
          break;
      default:
        status = undefined;
    }
  } else {
    status = undefined;
  }
  if (status !== undefined) {
    var match$1 = Core__Option.flatMap(obj["payout_id"], Core__JSON.Decode.string);
    var match$2 = Core__Option.flatMap(obj["merchant_id"], Core__JSON.Decode.string);
    var match$3 = Core__Option.flatMap(obj["customer_id"], Core__JSON.Decode.string);
    var match$4 = Core__Option.flatMap(obj["amount"], Core__JSON.Decode.$$float);
    var match$5 = Core__Option.flatMap(obj["currency"], Core__JSON.Decode.string);
    var match$6 = Core__Option.flatMap(obj["payout_type"], Core__JSON.Decode.string);
    var match$7 = Core__Option.flatMap(obj["connector"], Core__JSON.Decode.string);
    var match$8 = Core__Option.flatMap(obj["error_message"], Core__JSON.Decode.string);
    var match$9 = Core__Option.flatMap(obj["error_code"], Core__JSON.Decode.string);
    var match$10 = Core__Option.flatMap(obj["connector_transaction_id"], Core__JSON.Decode.string);
    if (match$1 === undefined) {
      return ;
    }
    if (match$2 === undefined) {
      return ;
    }
    if (match$3 === undefined) {
      return ;
    }
    if (match$4 === undefined) {
      return ;
    }
    if (match$5 === undefined) {
      return ;
    }
    if (match$6 === undefined) {
      return ;
    }
    var payoutSuccessResponse = {
      payoutId: match$1,
      merchantId: match$2,
      customerId: match$3,
      amount: match$4,
      currency: match$5,
      connector: match$7,
      payoutType: match$6,
      status: status,
      errorMessage: match$8,
      errorCode: match$9,
      connectorTransactionId: match$10
    };
    return {
            TAG: "SuccessResponse",
            _0: payoutSuccessResponse
          };
  }
  var match$11 = Core__Option.flatMap(obj["type"], Core__JSON.Decode.string);
  var match$12 = Core__Option.flatMap(obj["code"], Core__JSON.Decode.string);
  var match$13 = Core__Option.flatMap(obj["message"], Core__JSON.Decode.string);
  var match$14 = Core__Option.flatMap(obj["reason"], Core__JSON.Decode.string);
  if (match$11 === undefined) {
    return ;
  }
  if (match$12 === undefined) {
    return ;
  }
  if (match$13 === undefined) {
    return ;
  }
  var payoutFailureResponse = {
    errorType: match$11,
    code: match$12,
    message: match$13,
    reason: match$14
  };
  return {
          TAG: "ErrorResponse",
          _0: payoutFailureResponse
        };
}

function decodePaymentMethodTypeArray(jsonArray, defaultDynamicPmdFields) {
  var items = Core__JSON.Decode.array(jsonArray);
  if (items !== undefined) {
    return Core__Array.reduce(Belt_Array.keepMap(items, (function (__x) {
                      return decodePaymentMethodTypeWithRequiredFields(__x, defaultDynamicPmdFields);
                    })), [
                [],
                []
              ], (function (param, param$1) {
                  return [
                          param[0].concat(param$1[0]),
                          param[1].concat(param$1[1])
                        ];
                }));
  } else {
    return [
            [],
            []
          ];
  }
}

export {
  emailValidationRegex ,
  decodeAmount ,
  decodeFlow ,
  decodeFormLayout ,
  decodeCard ,
  decodeTransfer ,
  decodeWallet ,
  decodeBankRedirect ,
  getFieldOptions ,
  decodeFieldType ,
  customAddressOrder ,
  customPmdOrder ,
  createCustomOrderMap ,
  getCustomIndex ,
  sortByCustomOrder ,
  decodePayoutDynamicFields ,
  decodePaymentMethodTypeWithRequiredFields ,
  decodePayoutConfirmResponse ,
  decodePaymentMethodTypeArray ,
}
/* No side effect */
